// Для Имитации бэкенда: массив данных о товарах
const products = [
  {
    id: 1,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "M",
    color: "Red",
    imageUrl: "img/prod1.jpg",
  },
  {
    id: 2,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "S",
    color: "Red",
    imageUrl: "img/prod2.jpg",
  },
  {
    id: 3,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "XS",
    color: "Red",
    imageUrl: "img/prod3.png",
  },
  {
    id: 4,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "L",
    color: "Red",
    imageUrl: "img/prod4.png",
  },
  {
    id: 5,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "L",
    color: "Red",
    imageUrl: "img/prod5.png",
  },
  {
    id: 6,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "M",
    color: "Red",
    imageUrl: "img/prod6.png",
  },
  {
    id: 7,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "S",
    color: "Red",
    imageUrl: "img/prod7.png",
  },
  {
    id: 8,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "M",
    color: "Red",
    imageUrl: "img/prod8.png",
  },
  {
    id: 9,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "M",
    color: "Red",
    imageUrl: "img/prod9.png",
  },
  {
    id: 10,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "XS",
    color: "Red",
    imageUrl: "img/prod10.png",
  },
  {
    id: 11,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "S",
    color: "Red",
    imageUrl: "img/prod11.png",
  },
  {
    id: 12,
    title: "ELLERY X M'O CAPSULE",
    description:
      "Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.",
    price: 52.0,
    size: "XS",
    color: "Red",
    imageUrl: "img/prod12.png",
  },
];

export default products;